module.exports = __webpack_public_path__ + "static/media/lato-v15-latin-300.483a27c9.ttf";